import React, { useEffect, useState } from "react";
import axios from "axios";
import { logHistory } from "../../utils/historyLogger";
import "./Visitors.css";

function Visitors() {
  const [visitors, setVisitors] = useState([]);
  const role = localStorage.getItem("role");

  const canEdit = role === "admin" || role === "superadmin";
  const canDelete = role === "superadmin";
  const canAdd = role === "user" || role === "admin" || role === "superadmin";

  const [search, setSearch] = useState("");
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    date: "",
    visitorName: "",
    nicPassport: "",
    company: "",
    country: "",
    contact: "",
    purpose: "",
    sector: "Contractors",
    remarks: "",
    cost: "",

    refreshments: "No",
    refreshmentDetails: "",
    inTime: "",
    outTime: "",
    visitStatus: "Pending",

    breakfast: "No",
    lunch: "No",
    dinner: "No",
    accommodation: "No",
    accommodationPlace: "",
    arrivalDate: "",
    leavingDate: "",
    supplierStayStatus: "Still Staying",
  });

  useEffect(() => {
    fetchVisitors();
  }, []);

  const fetchVisitors = async () => {
    try {
      const res = await axios.get("https://hrpsc.swisstekaluminium.com/api/visitors");
      setVisitors(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const clearForm = () => {
    setEditingId(null);

    setFormData({
      date: "",
      visitorName: "",
      nicPassport: "",
      company: "",
      country: "",
      contact: "",
      purpose: "",
      sector: "Contractors",
      remarks: "",
      cost: "",

      refreshments: "No",
      refreshmentDetails: "",
      inTime: "",
      outTime: "",
      visitStatus: "Pending",

      breakfast: "No",
      lunch: "No",
      dinner: "No",
      accommodation: "No",
      accommodationPlace: "",
      arrivalDate: "",
      leavingDate: "",
      supplierStayStatus: "Still Staying",
    });
  };
    const handleSubmit = async () => {
    try {
      if (!formData.date || !formData.visitorName || !formData.nicPassport) {
        alert("Date, Visitor Name and NIC/Passport are mandatory");
        return;
      }

      if (editingId) {
        await axios.put(
          `https://hrpsc.swisstekaluminium.com/api/visitors/${editingId}`,
          formData
        );

        await logHistory(
          "Visitors",
          "Updated Visitor",
          `Visitor ${formData.visitorName} updated`
        );

        alert("Updated Successfully");
      } else {
        await axios.post("https://hrpsc.swisstekaluminium.com/api/visitors", formData);

        await logHistory(
          "Visitors",
          "Added Visitor",
          `Visitor ${formData.visitorName} added`
        );

        alert("Added Successfully");
      }

      fetchVisitors();
      clearForm();
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.message || "Error Saving Visitor");
    }
  };

  const handleEdit = (item) => {
    setEditingId(item.id);

    setFormData({
      date: item.date || "",
      visitorName: item.visitorName || "",
      nicPassport: item.nicPassport || "",
      company: item.company || "",
      country: item.country || "",
      contact: item.contact || "",
      purpose: item.purpose || "",
      sector: item.sector || "Contractors",
      remarks: item.remarks || "",
      cost: item.cost || "",

      refreshments: item.refreshments || "No",
      refreshmentDetails: item.refreshmentDetails || "",
      inTime: item.inTime || "",
      outTime: item.outTime || "",
      visitStatus: item.visitStatus || "Pending",

      breakfast: item.breakfast || "No",
      lunch: item.lunch || "No",
      dinner: item.dinner || "No",
      accommodation: item.accommodation || "No",
      accommodationPlace: item.accommodationPlace || "",
      arrivalDate: item.arrivalDate || "",
      leavingDate: item.leavingDate || "",
      supplierStayStatus: item.supplierStayStatus || "Still Staying",
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this visitor record?")) return;

    try {
      await axios.delete(`https://hrpsc.swisstekaluminium.com/api/visitors/${id}`);

      await logHistory(
        "Visitors",
        "Deleted Visitor",
        "Visitor record deleted"
      );

      fetchVisitors();
      alert("Deleted Successfully");
    } catch (err) {
      console.log(err);
      alert("Error Deleting Visitor");
    }
  };

  const toggleVisitStatus = async (item) => {
    try {
      const newStatus =
        item.visitStatus === "Visited" || item.visitStatus === "Completed"
          ? "Pending"
          : "Visited";

      await axios.put(`https://hrpsc.swisstekaluminium.com/api/visitors/${item.id}`, {
        ...item,
        visitStatus: newStatus,
      });

      await logHistory(
        "Visitors",
        "Updated Visitor Status",
        `Visitor ${item.visitorName} status changed to ${newStatus}`
      );

      fetchVisitors();
    } catch (err) {
      console.log(err);
      alert("Error Updating Status");
    }
  };
    const downloadCSVReport = () => {
    if (visitors.length === 0) {
      alert("No visitor data to download");
      return;
    }

    const headers = Object.keys(visitors[0]);

    const rows = visitors.map((item) =>
      headers
        .map((field) => `"${String(item[field] ?? "").replace(/"/g, '""')}"`)
        .join(",")
    );

    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "visitors_report.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  const filteredVisitors = visitors.filter((item) => {
    const text = search.toLowerCase();

    return (
      item.visitorName?.toLowerCase().includes(text) ||
      item.company?.toLowerCase().includes(text) ||
      item.nicPassport?.toLowerCase().includes(text) ||
      item.country?.toLowerCase().includes(text) ||
      item.sector?.toLowerCase().includes(text)
    );
  });

  const contractors = visitors.filter(
    (item) => item.sector === "Contractors"
  );

  const suppliers = visitors.filter(
    (item) => item.sector === "Suppliers"
  );

  const interviewers = visitors.filter(
    (item) => item.sector === "Interviewers"
  );

  const buyers = visitors.filter(
    (item) => item.sector === "Buyers"
  );

  return (
    <div className="visitor-page">
      <h1 className="page-title">Visitors Management</h1>

      <div className="dashboard-cards">
        <div className="dashboard-card">
          <h3>Total Visitors</h3>
          <h1>{visitors.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Contractors</h3>
          <h1>{contractors.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Suppliers</h3>
          <h1>{suppliers.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Interviewers</h3>
          <h1>{interviewers.length}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Buyers</h3>
          <h1>{buyers.length}</h1>
        </div>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search Visitor / Company / Category"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <button className="clear-btn" onClick={() => setSearch("")}>
          Clear
        </button>

        <button className="add-btn" onClick={downloadCSVReport}>
          Download Report
        </button>
      </div>

      {(canAdd || editingId) && (
        <div className="form-container">
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
          />

          <input
            type="text"
            name="visitorName"
            placeholder="Visitor Name"
            value={formData.visitorName}
            onChange={handleChange}
          />

          <input
            type="text"
            name="nicPassport"
            placeholder="NIC / Passport"
            value={formData.nicPassport}
            onChange={handleChange}
          />

          <input
            type="text"
            name="company"
            placeholder="Company"
            value={formData.company}
            onChange={handleChange}
          />

          <input
            type="text"
            name="country"
            placeholder="Country"
            value={formData.country}
            onChange={handleChange}
          />

          <input
            type="text"
            name="contact"
            placeholder="Contact"
            value={formData.contact}
            onChange={handleChange}
          />

          <input
            type="text"
            name="purpose"
            placeholder="Purpose"
            value={formData.purpose}
            onChange={handleChange}
          />

          <select
            name="sector"
            value={formData.sector}
            onChange={handleChange}
          >
            <option value="Contractors">Contractors</option>
            <option value="Suppliers">Suppliers</option>
            <option value="Interviewers">Interviewers</option>
            <option value="Buyers">Buyers</option>
          </select>

          <input
            type="text"
            name="remarks"
            placeholder="Remarks"
            value={formData.remarks}
            onChange={handleChange}
          />

          <input
            type="number"
            name="cost"
            placeholder="Cost"
            value={formData.cost}
            onChange={handleChange}
          />

          <select
            name="refreshments"
            value={formData.refreshments}
            onChange={handleChange}
          >
            <option value="Yes">Refreshments Yes</option>
            <option value="No">Refreshments No</option>
          </select>

          <input
            type="text"
            name="refreshmentDetails"
            placeholder="Refreshment Details"
            value={formData.refreshmentDetails}
            onChange={handleChange}
          />

          <input
            type="time"
            name="inTime"
            value={formData.inTime}
            onChange={handleChange}
          />

          <input
            type="time"
            name="outTime"
            value={formData.outTime}
            onChange={handleChange}
          />

          <select
            name="breakfast"
            value={formData.breakfast}
            onChange={handleChange}
          >
            <option value="Yes">Breakfast Yes</option>
            <option value="No">Breakfast No</option>
          </select>

          <select
            name="lunch"
            value={formData.lunch}
            onChange={handleChange}
          >
            <option value="Yes">Lunch Yes</option>
            <option value="No">Lunch No</option>
          </select>

          <select
            name="dinner"
            value={formData.dinner}
            onChange={handleChange}
          >
            <option value="Yes">Dinner Yes</option>
            <option value="No">Dinner No</option>
          </select>

          <select
            name="accommodation"
            value={formData.accommodation}
            onChange={handleChange}
          >
            <option value="Yes">Accommodation Yes</option>
            <option value="No">Accommodation No</option>
          </select>

          <input
            type="text"
            name="accommodationPlace"
            placeholder="Accommodation Place"
            value={formData.accommodationPlace}
            onChange={handleChange}
          />

          <input
            type="date"
            name="arrivalDate"
            value={formData.arrivalDate}
            onChange={handleChange}
          />

          <input
            type="date"
            name="leavingDate"
            value={formData.leavingDate}
            onChange={handleChange}
          />

          <div className="button-group">
            <button className="add-btn" onClick={handleSubmit}>
              {editingId ? "Update Visitor" : "Add Visitor"}
            </button>

            <button className="clear-btn" onClick={clearForm}>
              Clear Form
            </button>
          </div>
        </div>
      )}

      <div className="table-container">
        <h2>Visitor Records</h2>

        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Category</th>
              <th>Name</th>
              <th>NIC / Passport</th>
              <th>Company</th>
              <th>Country</th>
              <th>Contact</th>
              <th>Purpose</th>
              <th>Refreshments</th>
              <th>Details</th>
              <th>In</th>
              <th>Out</th>
              <th>Breakfast</th>
              <th>Lunch</th>
              <th>Dinner</th>
              <th>Accommodation</th>
              <th>Place</th>
              <th>Arrival</th>
              <th>Leaving</th>
              <th>Cost</th>
              <th>Remarks</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredVisitors.length > 0 ? (
              filteredVisitors.map((item) => (
                <tr key={item.id}>
                  <td>{item.date}</td>
                  <td>{item.sector}</td>
                  <td>{item.visitorName}</td>
                  <td>{item.nicPassport}</td>
                  <td>{item.company}</td>
                  <td>{item.country}</td>
                  <td>{item.contact}</td>
                  <td>{item.purpose}</td>
                  <td>{item.refreshments}</td>
                  <td>{item.refreshmentDetails}</td>
                  <td>{item.inTime}</td>
                  <td>{item.outTime}</td>
                  <td>{item.breakfast}</td>
                  <td>{item.lunch}</td>
                  <td>{item.dinner}</td>
                  <td>{item.accommodation}</td>
                  <td>{item.accommodationPlace}</td>
                  <td>{item.arrivalDate}</td>
                  <td>{item.leavingDate}</td>
                  <td>Rs. {item.cost}</td>
                  <td>{item.remarks}</td>

                  <td>
                    {canEdit ? (
                      <button
                        className={
                          item.visitStatus === "Visited" ||
                          item.visitStatus === "Completed"
                            ? "status-active"
                            : "status-pending"
                        }
                        onClick={() => toggleVisitStatus(item)}
                      >
                        {item.visitStatus || "Pending"}
                      </button>
                    ) : (
                      <span
                        className={
                          item.visitStatus === "Visited" ||
                          item.visitStatus === "Completed"
                            ? "status-active"
                            : "status-pending"
                        }
                      >
                        {item.visitStatus || "Pending"}
                      </span>
                    )}
                  </td>

                  <td>
                    {canEdit && (
                      <button
                        className="edit-btn"
                        onClick={() => handleEdit(item)}
                      >
                        Edit
                      </button>
                    )}

                    {canDelete && (
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(item.id)}
                      >
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="23"
                  style={{
                    textAlign: "center",
                    padding: "30px",
                    color: "gray",
                  }}
                >
                  No Visitor Records Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Visitors;